<template>
  <AppRow permission="WITHDRAW_ADMINISTRATION">
    <template v-slot>
      <v-col cols="12">
        <DatePicker
          label="Дата создания (выбрать промежуток)"
          @save="saveDates"
        />
      </v-col>
      <v-col cols="12">
        <ApolloQuery
          :query="require('../graphql/queries/getOutInForLast24Hours.graphql')"
          :variables="{
            purseType: selectedPurseType,
          }"
        >
          <template v-slot="{ result: { data: outInData }, isLoading: withdrawsIsLoading }">
            <v-row
              :loading="withdrawsIsLoading === 1"
              class="px-4 pb-3"
              style="display: flex; align-items: center; justify-content: center;"
              flat
            >
              <v-col>
                <v-select
                  v-model="selectedPurseType"
                  :items="purseTypes"
                  background-color="#464646"
                  class="rounded-lg"
                  flat
                  hide-details="auto"
                  label="Валюта"
                  solo
                />
              </v-col>
              <v-col style="display: flex; width: 100%; height: 100%;">
                <v-chip style="margin: auto">
                  {{outInData !== undefined && outInData.getOutInForLast24Hours !== undefined ? 0.01 * Math.ceil(10000 * outInData.getOutInForLast24Hours.outIn) : 0}}%
                </v-chip>
              </v-col>
            </v-row>
          </template>
        </ApolloQuery>
      </v-col>

      <v-col>
        <ApolloQuery
          :query="require('../graphql/queries/getWithdrawsByCategory.gql')"
          :variables="{
            category,
            createdFrom,
            createdTo,
            pageIndex: (page - 1) * itemsPerPage,
            pageSize: itemsPerPage,
          }"
        >
          <ApolloSubscribeToMore
            :document="require('../graphql/subscriptions/onNewWithdrawRequest.gql')"
            :update-query="onWithdrawAdded"
          />

          <template v-slot="{ result: { error: withdrawsError, data: withdrawsData }, isLoading: withdrawsIsLoading }">
            <!-- Error -->
            <AppNotification
              v-if="withdrawsError"
              :message="withdrawsError.message"
            />

            <!-- Result -->
            <v-card
              v-else-if="withdrawsData || withdrawsIsLoading === 1"
              :loading="withdrawsIsLoading === 1"
              class="px-4 pb-3"
              flat
            >
              <template v-if="withdrawsData">
                <v-card-title>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="6"
                    >
                      Выводы: {{ withdrawsData.getWithdrawsByCategory.total }}
                    </v-col>
                    <v-col class="text-right d-sm-block d-flex justify-center">
                      <v-btn-toggle
                        v-model="category"
                        mandatory
                      >
                        <v-btn
                          color="success"
                          value="GREEN"
                          @click="firstPage"
                        >
                          <span class="hidden-sm-and-down">Зелёная</span>
                        </v-btn>
                        <v-btn
                          color="purple"
                          value="VIOLET"
                          @click="firstPage"
                        >
                          <span class="hidden-sm-and-down">Фиолетовая</span>
                        </v-btn>
                        <v-btn
                          color="error"
                          value="RED"
                          @click="firstPage"
                        >
                          <span class="hidden-sm-and-down">Красная</span>
                        </v-btn>
                      </v-btn-toggle>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="withdrawsData.getWithdrawsByCategory.withdraws"
                  :items-per-page="itemsPerPage"
                  disable-sort
                  hide-default-footer
                  style="white-space: pre-line"
                >
                  <template v-slot:top>
                    <ApolloMutation
                      :mutation="require(
                        !accept
                          ? '../graphql/mutations/denyWithdraw.gql'
                          : walletType === 'manual_withdraw'
                            ? '../graphql/mutations/acceptManualWithdraw.gql'
                            : '../graphql/mutations/acceptWithdraw.gql'
                      )"
                      :refetch-queries="refetchQueriesAfterMyMutation"
                      :variables="walletType === 'manual_withdraw'
                        ? {
                          withdrawId: id,
                          status: 'PENDING',
                        }
                        : {
                          id,
                          reason,
                        }"
                    >
                      <template v-slot="{ mutate, loading, error: acceptOrDenyError }">
                        <v-dialog
                          v-model="dialog"
                          max-width="400px"
                          persistent
                        >
                          <v-card :loading="loading">
                            <v-card-title>{{ dialogTitle }}</v-card-title>
                            <v-card-text v-if="!accept">
                              <v-select
                                v-model="denyReasonValue"
                                :items="denyReasons"
                                label="Причина отклонения"
                                @change="onDenyReasonChange"
                              />
                              <v-row
                                v-if="denyReasonValue === amountReason"
                                dense
                              >
                                <v-col cols="7">
                                  <v-text-field
                                    v-model="denyAmount"
                                    label="Сумма"
                                    type="number"
                                  />
                                </v-col>
                                <v-col cols="5">
                                  <v-text-field
                                    v-model="denyCurrency"
                                    label="Валюта"
                                  />
                                </v-col>
                              </v-row>
                              <v-textarea
                                v-model="reason"
                                auto-grow
                                rows="2"
                                label="Причина (текст для игрока)"
                              />
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer />

                              <v-btn
                                color="primary"
                                text
                                @click="dialog = false"
                              >
                                Отмена
                              </v-btn>
                              <v-btn
                                :disabled="denyDisabled"
                                color="error"
                                text
                                @click="mutate()"
                              >
                                {{ buttonText }}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <AppNotification
                          v-if="acceptOrDenyError"
                          :icon-disabled="true"
                          :message="acceptOrDenyError.message"
                        />
                      </template>
                    </ApolloMutation>
                  </template>

                  <template v-slot:[`item.createdAt`]="{ item }">
                    {{ item.createdAt | moment('DD.MM.YYYY, HH:mm') }}
                  </template>

                  <template v-slot:[`item.amount`]="{ item }">
                    {{ item.amount }}
                  </template>

                  <template v-slot:[`item.accountNumber`]="{ item }">
                    {{ getAccountNumber(item.accountNumber) }}
                  </template>

                  <template v-slot:[`item.segment`]="{ item }">
                    {{ item.segment || 'not VIP' }}
                  </template>

                  <template v-slot:[`item.outIn`]="{ item }">
                    <span style="white-space: nowrap">
                      {{ item.outIn ? (100 * item.outIn).toFixed(0) : item.outIn }}%
                      <v-menu
                        :close-on-content-click="false"
                        offset-y
                      >
                        <template #activator="{ on, attrs }">
                          <v-icon
                            small
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <v-card
                          class="pa-4"
                          max-width="380"
                        >
                          <ApolloQuery
                            :query="require('../graphql/queries/getWithdrawOutInDetails.gql')"
                            :variables="{ withdrawId: +item.id }"
                          >
                            <template #default="{ result: { data: outInDetails }, isLoading: outInDetailsLoading }">
                              <div v-if="outInDetailsLoading === 1">Загрузка...</div>
                              <template v-else-if="outInDetails && outInDetails.getWithdrawOutInDetails">
                                <div>Out/In за последние 30 дней: {{ formatOutIn(outInDetails.getWithdrawOutInDetails.last30Days) }}</div>
                                <div>Out/In за последние 30 дней, если одобрить эту заявку: {{ formatOutIn(outInDetails.getWithdrawOutInDetails.last30DaysWithRequest) }}</div>
                              </template>
                              <div v-else>Нет данных</div>
                            </template>
                          </ApolloQuery>
                        </v-card>
                      </v-menu>
                    </span>
                  </template>

                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      :to="{ name: 'users', params: { id: item.userId }}"
                      class="text-none"
                      depressed
                      height="36"
                      x-small
                      style="margin-top: .4rem"
                    >
                      Подробнее об игроке
                    </v-btn>
                    <v-btn
                      class="text-none ma-1"
                      depressed
                      height="36"
                      x-small
                      style="margin-top: .7rem !important"
                      @click.stop="denyWithdraw(item)"
                    >
                      Отклонить
                    </v-btn>
                    <v-btn
                      class="text-none ma-1"
                      color="primary"
                      depressed
                      height="36"
                      x-small
                      style="margin-top: .7rem !important"
                      @click.stop="acceptWithdraw(item)"
                    >
                      Одобрить
                    </v-btn>
                  </template>
                </v-data-table>
                <v-divider />

                <div class="text-center pt-3">
                  <v-pagination
                    v-model="page"
                    :length="withdrawsData.getWithdrawsByCategory.pages"
                    :total-visible="9"
                  />

                  <v-select
                    v-model="itemsPerPage"
                    :items="[5, 10, 15]"
                    class="pa-4 pt-5"
                    label="Строк на странице"
                    @change="firstPage"
                  />
                </div>
              </template>
            </v-card>

            <!-- No result -->
            <AppNotification
              v-else
              message="Нет результата :("
            />
          </template>
        </ApolloQuery>
      </v-col>
    </template>
  </AppRow>
</template>

<style scoped>

</style>

<script>
import AppRow from '@/components/AppRow.vue';
import DatePicker from '@/components/DatePicker.vue';
import AppNotification from '@/components/AppNotification.vue';
import getWithdrawsByCategory from '@/graphql/queries/getWithdrawsByCategory.gql';
import { WITHDRAW_DENY_REASONS, AMOUNT_REASON, buildDenyReasonText } from '@/constants/withdrawDenyReasons';

export default {
  components: {
    AppRow,
    DatePicker,
    AppNotification,
  },
  data() {
    return {
      createdFrom: '',
      createdTo: '',
      category: 'GREEN',
      headers: [
        { text: 'userId', value: 'userId', class: 'white--text text-subtitle-2' },
        { text: 'Сегмент', value: 'segment', class: 'white--text text-subtitle-2' },
        { text: 'Баланс', value: 'balance', class: 'white--text text-subtitle-2' },
        { text: 'Валюта', value: 'purseType', class: 'white--text text-subtitle-2' },
        { text: 'Дата заявки', value: 'createdAt', class: 'white--text text-subtitle-2' },
        { text: 'Вывод', value: 'amount', class: 'white--text text-subtitle-2' },
        { text: 'Номер счета', value: 'accountNumber', class: 'white--text text-subtitle-2' },
        { text: 'Сумма депозитов', value: 'depositAmount', class: 'white--text text-subtitle-2' },
        { text: 'Сумма выводов', value: 'withdrawAmount', class: 'white--text text-subtitle-2' },
        { text: 'Out/In', value: 'outIn', class: 'white--text text-subtitle-2' },
        { text: '', value: 'action', align: 'center' },
      ],
      page: 1,
      itemsPerPage: 5,
      dialog: false,
      accept: false,
      id: '',
      reason: '',
      denyReasons: WITHDRAW_DENY_REASONS,
      denyReasonValue: null,
      amountReason: AMOUNT_REASON,
      denyAmount: '',
      denyCurrency: '',
      purseType: null,
      walletType: null,
      selectedPurseType: 'MXN',
      purseTypes: [
        'INR',
        'MYR',
        'BTC',
        'USD',
        'EUR',
        'ETC',
        'UAH',
        'RUB',
        'LTC',
        'DEMO',
        'ETH',
        'BRL',
        'BCH',
        'BNB',
        'DASH',
        'DOGE',
        'TRX',
        'USDT',
        'XMR',
        'ZEC',
        'XRP',
        'KZT',
        'VND',
        'UZS',
        'IDR',
        'AZN',
        'KGS',
        'PKR',
        'BDT',
        'CLP',
        'PEN',
        'COP',
        'MXN',
        'PYG',
        'UYU',
        'BOB',
        'CRC',
        'GTQ',
        'PAB',
        'NIO',
        'ARS',
        'SVC',
        'NGN',
      ],
    };
  },
  computed: {
    dateRangeText() {
      return this.dates.join(' ~ ');
    },
    dialogTitle() {
      return this.accept ? 'Одобрить заявку на вывод' : 'Отклонить заявку на вывод';
    },
    buttonText() {
      return this.accept ? 'Одобрить' : 'Отклонить';
    },
    denyDisabled() {
      if (this.accept) return false;
      if (!this.reason.trim()) return true;
      // Не даём отправить причину 4 с незаполненной суммой ("...").
      return this.denyReasonValue === this.amountReason && this.reason.includes('...');
    },
  },
  watch: {
    denyAmount() {
      this.rebuildDenyReason();
    },
    denyCurrency() {
      this.rebuildDenyReason();
    },
  },
  methods: {
    initPurseType(val) {
      switch (val) {
        case 0:
          return 'INR';
        case 1:
          return 'BTC';
        case 2:
          return 'USD';
        case 3:
          return 'EUR';
        case 4:
          return 'ETC';
        case 5:
          return 'UAH';
        case 6:
          return 'RUB';
        case 7:
          return 'LTC';
        case 8:
          return 'DEMO';
        case 9:
          return 'ETH';
        case 10:
          return 'BRL';
        case 11:
          return 'BCH';
        case 12:
          return 'BNB';
        case 13:
          return 'DASH';
        case 14:
          return 'DOGE';
        case 15:
          return 'TRX';
        case 16:
          return 'USDT';
        case 17:
          return 'XMR';
        case 18:
          return 'ZEC';
        case 19:
          return 'XRP';
        case 20:
          return 'KZT';
        case 21:
          return 'VND';
        case 22:
          return 'UZS';
        case 23:
          return 'IDR';
        case 24:
          return 'AZN';
        case 25:
          return 'KGS';
        case 26:
          return 'PKR';
        case 27:
          return 'BDT';
        case 28:
          return 'CLP';
        case 29:
          return 'PEN';
        case 30:
          return 'COP';
        case 31:
          return 'MXN';
        case 32:
          return 'PYG';
        case 33:
          return 'UYU';
        case 34:
          return 'BOB';
        case 35:
          return 'CRC';
        case 36:
          return 'GTQ';
        case 37:
          return 'PAB';
        case 38:
          return 'NIO';
        case 39:
          return 'ARS';
        case 40:
          return 'SVC';
        case 41:
          return 'NGN';
        case 42:
          return 'MYR';
        default:
          return undefined;
      }
    },
    saveDates(dates) {
      [this.createdFrom, this.createdTo] = dates;
    },
    onWithdrawAdded(previousResult, { subscriptionData }) {
      const newResult = {
        getWithdrawsByCategory: [...previousResult.getWithdrawsByCategory],
      };
      newResult.getWithdrawsByCategory.push(subscriptionData.data.onNewWithdrawRequest);
      return newResult;
    },
    refetchQueriesAfterMyMutation() {
      this.dialog = false;

      return [{
        query: getWithdrawsByCategory,
        variables: {
          category: this.category,
          createdFrom: this.createdFrom,
          createdTo: this.createdTo,
          pageIndex: (this.page - 1) * this.itemsPerPage,
          pageSize: this.itemsPerPage,
        },
      }];
    },
    denyWithdraw(item) {
      this.dialog = true;
      this.accept = false;
      this.walletType = item.walletType;
      this.id = +item.id;
      this.purseType = item.purseType;
      this.denyReasonValue = null;
      this.denyAmount = '';
      this.denyCurrency = item.purseType;
      this.reason = '';
    },
    onDenyReasonChange() {
      this.rebuildDenyReason();
    },
    rebuildDenyReason() {
      const reason = this.denyReasons.find(it => it.value === this.denyReasonValue);
      const amountText = this.denyAmount ? `${this.denyAmount} ${this.denyCurrency}`.trim() : '';
      this.reason = buildDenyReasonText(reason, this.purseType, amountText);
    },
    acceptWithdraw(item) {
      this.dialog = true;
      this.accept = true;
      this.walletType = item.walletType;
      this.id = +item.id;
      this.reason = '';
    },
    firstPage() {
      this.page = 1;
    },
    formatOutIn(value) {
      if (value === null || value === undefined) return '—';
      return `${(100 * value).toFixed(0)}%`;
    },
    getAccountNumber(str) {
      try {
        const dict = JSON.parse(str);

        return [...Object.entries(dict)]
          .filter(it => it[0] !== 'store_values_checkbox')
          .map(it => it.join(': '))
          .join('\n');
      } catch (e) {
        console.error(e);
        return str;
      }
    },
  },
};
</script>
